import React from 'react';
import { Row, Col, Typography, Space } from 'antd';

const { Title, Text } = Typography;

interface PageHeaderProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  extra?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  icon,
  extra,
  style,
  className
}) => {
  return (
    <div 
      className={`page-header ${className || ''}`} 
      style={{ 
        marginBottom: 24, 
        ...style 
      }}
    >
      <Row justify="space-between" align="middle">
        <Col>
          <Title level={2} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
            {icon}
            {title}
          </Title>
          {description && (
            <Text type="secondary" style={{ fontSize: 14 }}>
              {description}
            </Text>
          )}
        </Col>
        {extra && (
          <Col>
            <Space>
              {extra}
            </Space>
          </Col>
        )}
      </Row>
    </div>
  );
};

PageHeader.displayName = 'PageHeader';

export default PageHeader;
